var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1ElectricalChargingStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 58a8 8 0 00-6-6.74V14a7 7 0 00-7-7H14a7 7 0 00-7 7v28a7 7 0 007 7h6v19.91h32V18H20v27h-6a3 3 0 01-3-3V14a3 3 0 013-3h44a3 3 0 013 3v37.26A8 8 0 0055 58v5h3v6h3v-6h4v6h3v-6h3v-5zM24 22h24v43H24V22zm4 4h16v16H28V26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Electrical_charging_station.f4efdc91.svg";
export { SvgI1ElectricalChargingStation as ReactComponent };